export default __webpack_public_path__ + "static/media/bulk-balance.e99dc95c.csv";